<template>
  <el-row class="group-management" :gutter="24" style="background: transparent">
    <management-toolbar><el-button type="primary" icon="el-icon-plus" :disabled="savingCarta" @click="openNewGroup">Añadir grupo</el-button></management-toolbar>
    <!--MUESTRA LAS FILAS DE LOS GRUPOS-->
    <el-row v-for="item in data" v-bind:key="item.key" class="group-row">
      <!--ICONO-->
      <el-col :span="3" class="border-col group-icon">
        <el-image
          v-if="item.iconImage || iconos[item.icon]"
          class="groups-icon"
          :src="item.iconImage ? photoUrl(item.iconImage) : iconos[item.icon].url"
        ></el-image>
      </el-col>
      <!--NOMBRE GRUPO-->
      <el-col :span="15" class="border-col group-name" style="justify-content: left">{{
        item.group
      }}</el-col>
      <!--ICONOS EDIT-->
      <el-col :span="6" class="group-actions">
        <el-row class="icons-modify">
          <!--ARROWS-->
          <el-col type="flex" justify="center">
            <!--ARROW UP-->
            <el-button
              style="
                padding: 0vw;
                border: none;

                width: 100%;
              "
              v-on:click="moveUP(item)"
             :aria-label="'Subir ' + item.group">
              <i
                class="el-icon-arrow-up"
                style=" color: black"
              ></i>
            </el-button>
            <!--ARROW DOWN-->
            <el-button
              style="
                padding: 0vw;
                border: none;

                width: 100%;
                margin: 0px;
              "
              v-on:click="moveDOWN(item)"
             :aria-label="'Bajar ' + item.group">
              <i
                class="el-icon-arrow-down"
                style=" color: black"
              ></i>
            </el-button>
          </el-col>
          <!--ENABLE-->
          <el-col class="border-col">
            <el-switch
              v-model="item.enable"
              @change="changeStatus()"
              style="width: 5vw"
            ></el-switch>
          </el-col>
          <el-col class="border-col group-home-control">
            <el-button size="small" icon="el-icon-house" :type="item.showOnHome ? 'primary' : 'default'"
              :aria-pressed="item.showOnHome === true" :disabled="savingCarta"
              :aria-label="(item.showOnHome ? 'Ocultar en inicio ' : 'Mostrar en inicio ') + item.group"
              :title="item.showOnHome ? 'Ocultar este grupo en el inicio de la carta' : 'Mostrar este grupo en el inicio de la carta'"
              @click="toggleHome(item)">{{ item.showOnHome ? 'En inicio' : 'Mostrar en inicio' }}</el-button>
          </el-col>
          <!--MODIFY-->
          <el-col class="border-col">
            <el-button
              v-on:click="modifyGroup(item)"
              style="padding: 0vw; border: none; "
             :aria-label="'Editar ' + item.group">
              <i class="el-icon-edit" style=" color: black"></i>
            </el-button>
          </el-col>
          <!--DELETE-->
          <el-col class="border-col">
            <el-button
              style="padding: 0vw; border: none; "
              v-on:click="borrarGrupo(item)"
             :aria-label="'Eliminar ' + item.group">
              <i
                class="el-icon-delete-solid"
                style=" color: black"
              ></i>
            </el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!--DIALOGS-->
    <el-row>
      <!--DIALOG EDIT-->
      <el-dialog
        title="Editar grupo"
        :visible.sync="dialogVisible"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-row type="flex" justify="start" style="margin-left: 3vw">
          <el-row>
            <el-image
              v-if="iconImage || iconos[icono]"
              :src="iconImage ? photoUrl(iconImage) : iconos[icono].url"
              style="
                width: 3.5vw;
                padding: 0.5vw;
                margin: 0.5vw;
                border: 0.2vw solid black;
                border-radius: 10px;
              "
            ></el-image>
          </el-row>
          <el-row
            style="display: flex; align-items: center; justify-content: center"
          >
            <span class="management-field"><label for="grupos-field-0">Nombre del grupo</label><el-input
              placeholder="Grupo"
              v-model="groupSelected"
              style="margin-left: 2vw; width: 40vw"
              maxlength="16"
              show-word-limit
             id="grupos-field-0"></el-input></span>
          </el-row>
        </el-row>

        <span>
          <div
            style="

              color: black;
              text-align: left;
              margin-left: 3vw;
              margin-top: 2vh;
              margin-bottom: 2vh;
            "
          >
            Elija su icono:
          </div>
          <el-button
            v-for="icon in iconos"
            :key="icon.key"
            style="padding: 0vw; border: none; "
            v-on:click="setIcon(icon.key)"
          >
            <el-image :src="icon.url" class="dialog-image"></el-image>
          </el-button>
        </span>
        <custom-icon-picker v-if="dialogVisible" :key="'edit-'+iconSession" ref="editIcon" v-model="iconImage" />
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogVisible = false"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="saveGroup()"
            :loading="savingCarta || savingIcon"
           type="primary">
            Guardar
          </el-button>
        </span>
      </el-dialog>
      <!--DIALOG NEW-->
      <el-dialog
        title="Nuevo grupo"
        :visible.sync="dialogNuevo"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-row type="flex" justify="start" style="margin-left: 3vw">
          <el-row>
            <el-image
              v-if="iconImage || iconos[icono]"
              :src="iconImage ? photoUrl(iconImage) : iconos[icono].url"
              style="
                width: 3.5vw;
                padding: 0.5vw;
                margin: 0.5vw;
                border: 0.2vw solid black;
                border-radius: 10px;
              "
            ></el-image>
          </el-row>
          <el-row
            style="display: flex; align-items: center; justify-content: center"
          >
            <span class="management-field"><label for="grupos-field-1">Nombre del grupo</label><el-input
              placeholder="Grupo"
              v-model="grupo"
              style="margin-left: 2vw; width: 40vw"
              maxlength="21"
              show-word-limit
             id="grupos-field-1"></el-input></span>
          </el-row>
        </el-row>
        <span>
          <div
            style="

              color: black;
              text-align: left;
              margin-left: 3vw;
              margin-top: 2vh;
              margin-bottom: 2vh;
            "
          >
            Elija su icono:
          </div>
          <el-button
            v-for="icon in iconos"
            :key="icon.key"
            style="padding: 0vw; border: none; "
            v-on:click="setIcon(icon.key)"
          >
            <el-image :src="icon.url" class="dialog-image"></el-image>
          </el-button>
        </span>
        <custom-icon-picker v-if="dialogNuevo" :key="'new-'+iconSession" ref="newIcon" v-model="iconImage" />
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogNuevo = false"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="newGroup(grupo)"
           type="primary">
            Guardar
          </el-button>
        </span>
      </el-dialog>
      <!--DIALOG DELETE-->
      <el-dialog
        title="Eliminar grupo"
        :visible.sync="dialogDelete"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        ¿Desea eliminar el grupo?
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogDelete = false"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="deleteGroup()"
           type="danger">Eliminar</el-button>
        </span>
      </el-dialog>
    </el-row>
  </el-row>
</template>
<script>
import * as api from "../api/request.js";
import storage from "../api/storage.js";
import CustomIconPicker from '../components/CustomIconPicker.vue';
import ManagementToolbar from "../components/ManagementToolbar.vue";
import { prepareGroups, createGroupId } from "../utils/cartaEditing";
export default {
  components: { ManagementToolbar, CustomIconPicker },
  data() {
    return {
      version: undefined,
      savingCarta: false,
      savingIcon:false,
      pendingCartaSave: false,
      groupSelected: "",
      logo: "",
      icono: 0,
      iconImage: "",
      iconSession: 0,
      grupo: "",
      key: 0,
      dialogVisible: false,
      dialogNuevo: false,
      dialogDelete: false,
      iconos: [],
      data: [],
    };
  },
  mounted() {
    this.authenticated = storage.loadAuthenticated();
    if (this.authenticated === false || this.authenticated === null) {
      this.$router.replace({ name: "login" });
    } else {
      this.loadData();
    }
  },
  computed: {
    getData: function () {
      return this.data;
    },
  },
  methods: {
    photoUrl: api.imageUrl,
    openNewGroup(){this.groupSelected="";this.icono=0;this.iconImage="";this.iconSession++;this.dialogNuevo=true;},
    toggleHome(item) {
      this.$set(item, "showOnHome", !item.showOnHome);
      this.setData();
    },
    changeStatus: async function () {
      this.setData();
    },
    setData: async function () {
      if (this.savingCarta) { this.pendingCartaSave = true; return false; }
      this.savingCarta = true;
      try {
        do {
          this.pendingCartaSave = false;
          const result = await api.setCarta(JSON.parse(JSON.stringify(this.data)), this.version);
          this.version = result.version;
          if (!this.pendingCartaSave) this.data = result.carta;
        } while (this.pendingCartaSave);
        return true;
      } catch (error) {
        this.$message.error("No se han guardado los cambios. Recargando la carta.");
        await this.loadData();
        return false;
      } finally { this.savingCarta = false; this.pendingCartaSave = false; }
    },
    handleNodeClick(data) {
      console.log(data);
    },
    loadData: async function () {
      const snapshot = await api.getCartaCompleta();
      this.data = prepareGroups(snapshot.carta);
      this.version = snapshot.version;
      this.iconos = await api.getIconos();
    },
    deleteGroup: function () {
      this.data.splice(this.key, 1);
      var num = 0;
      this.data.forEach((group) => {
        group.key = num;
        num++;
      });
      this.dialogDelete = false;
      this.setData();
    },
    modifyGroup: function (item) {
      this.iconImage = item.iconImage || "";
      this.iconSession++;
      this.groupSelected = item.group;
      this.icono = item.icon;
      this.key = item.key;
      this.dialogVisible = true;
    },
    moveUP: function (object) {
      if (object.key > 0) {
        const index = object.key;
        const next = index + (-1);
        const copy = this.data[index];
        this.$set(this.data, index, this.data[next]);
        this.$set(this.data, next, copy);
        this.data.forEach((group, key) => { group.key = key; });
        this.setData();
      }
    },
    moveDOWN: function (object) {
      if (object.key < this.data.length - 1) {
        const index = object.key;
        const next = index + (1);
        const copy = this.data[index];
        this.$set(this.data, index, this.data[next]);
        this.$set(this.data, next, copy);
        this.data.forEach((group, key) => { group.key = key; });
        this.setData();
      }
    },
    setIcon: function (icon) {
      this.icono = icon;
      this.iconImage = "";
      const picker=this.$refs.editIcon || this.$refs.newIcon;if(picker)picker.select("");
    },
    getIconEdit: function (icon) {
      return require("../assets/edit icons/" + icon + ".png");
    },
    getIconActive: function () {
      if (this.icono == "") return require("../assets/grupos/undefined.png");
      return require("../assets/grupos/" + this.icono + ".png");
    },
    async saveGroup() {
      if(this.savingCarta || this.savingIcon)return;
      if(!this.groupSelected.trim())return this.$message.error("Indica el nombre del grupo.");
      this.savingIcon=true;
      try{this.iconImage=await this.$refs.editIcon.upload();}catch(e){return this.$message.error("No se pudo guardar el icono.");}finally{this.savingIcon=false;}
      this.$set(this.data[this.key],"iconImage",this.iconImage);
      this.data[this.key].group = this.groupSelected.toUpperCase();
      this.data[this.key].icon = this.icono;
      this.groupSelected = "";
      this.icono = "";
      this.grupo = "";
      this.dialogVisible = false;
      this.setData();
    },
    newGroup: async function (name) {
      if(this.savingCarta || this.savingIcon)return;
      if(!name.trim())return this.$message.error("Indica el nombre del grupo.");
      this.savingIcon=true;
      try{this.iconImage=await this.$refs.newIcon.upload();}catch(e){return this.$message.error("No se pudo guardar el icono.");}finally{this.savingIcon=false;}
      if (name != "") {
        this.data.push({
          group: name.toUpperCase(),
          key: this.data.length,
          enable: true,
          id: createGroupId(),
          showOnHome: false,
          icon: this.icono,
          iconImage: this.iconImage,
          plu: [],
        });
        this.dialogNuevo = false;
        this.groupSelected = "";
        this.icono = "";
        this.grupo = "";
      }
      this.setData();
    },
    borrarGrupo: function (item) {
      this.iconImage = item.iconImage || "";
      this.iconSession++;
      this.groupSelected = item.group;
      this.key = item.key;
      this.groupSelected = "";
      this.icono = "";
      this.grupo = "";
      this.dialogDelete = true;
    },
  },
};
</script>


<style scoped>
.group-row { padding: 8px 12px; }
.group-row .group-icon { flex: 0 0 64px; width: 64px; }
.group-row .group-name { flex: 1; width: auto; min-width: 0; padding: 0 12px; overflow-wrap: anywhere; }
.group-row .group-actions { flex: 0 0 auto; width: auto; }
.group-actions .icons-modify { gap: 12px; }
.group-actions .group-home-control { flex: 0 0 auto; width: auto; padding: 0; }
.group-home-control .el-button { width: 160px; }
@media(max-width:650px) { .group-row .group-actions { flex-basis: 100%; width: 100%; padding: 8px 0 0; } .group-actions .icons-modify { gap: 6px; } }
</style>
